import { HqoClientSdk, SdkEvents } from '@hqo/hqo-miniapp-client-sdk';
import { useMiniappSdkEventHandler } from 'app/shared/hooks/use-miniapp-sdk/use-miniapp-sdk.hooks';
import { useMiniappSdk } from 'app/shared/contexts/miniapp-sdk';
import { Paper } from 'app/components/ui/paper';
import { Button } from '@hqo/ui-atoms';
import React, { useCallback, useState } from 'react';

type ActionGroups = keyof Pick<HqoClientSdk, 'host' | 'identity' | 'payments' | 'storage' | 'header'>;

interface MiniappSdkMethodDemoProps<AG extends ActionGroups> {
  actionGroup: AG;
  action: keyof HqoClientSdk[AG];
  eventName: SdkEvents;
  children?: React.ReactNode;
  args?: unknown[];
}

export const MiniappSdkMethodDemo = <AG extends ActionGroups>({
  action,
  actionGroup,
  eventName,
  children,
  args = [],
}: MiniappSdkMethodDemoProps<AG>): JSX.Element => {
  const [eventData, setEventData] = useState<string | null>(null);
  const client = useMiniappSdk();

  useMiniappSdkEventHandler(
    eventName,
    (data: unknown) => {
      setEventData(JSON.stringify(data, null, 2));
    },
    [setEventData],
  );

  const handleClick = useCallback(() => {
    const emitAction = client[actionGroup][action];

    if (typeof emitAction === 'function') {
      emitAction(...args);
    }
  }, [action, actionGroup, args, client]);

  return (
    <Paper className="flex flex-col p-2 gap-2 items-start overflow-x-hidden">
      <Button
        onClick={handleClick}
        className="h-auto"
        variant="default"
      >
        {`${actionGroup}.${String(action)}`}
      </Button>
      {children}
      <div className="flex flex-col overflow-x-scroll w-full">
        <pre className="text-sm">{eventData}</pre>
      </div>
    </Paper>
  );
};
